import { render, staticRenderFns } from "./productBrand.vue?vue&type=template&id=cdb40f02&"
import script from "./productBrand.vue?vue&type=script&lang=js&"
export * from "./productBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports